<template>
  <v-dialog
    v-model="openDialog"
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="openDialog = false"
    @keydown.enter="$emit('confirm')"
  >
    <v-card block flat>
      <v-card-title class="title">
        {{ $t('confirmation') }}
      </v-card-title>
      <v-card-text class="text-xs-left subheading">
        <v-alert :type="type" :value="true" outline>
          <slot />
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary text-none"
          @click="$emit('confirm')"
          :loading="loading"
        >
          {{ $t('yes') }}
        </v-btn>
        <v-btn class="error--text text-none" flat @click="closeDialog">
          {{ $t('no') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'error',
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  watch: {
    value(newVal) {
      this.openDialog = newVal;
    },
    openDialog(newVal) {
      this.$emit('input', newVal);
    },
  },
  data() {
    return {
      openDialog: false,
    };
  },
  created() {
    this.openDialog = this.value;
  },
  methods: {
    closeDialog() {
      this.openDialog = false;
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped></style>
